export default function toQueryString(params) {
    const queryString = Object.keys(params)
        .filter(key => params[key] !== undefined && params[key] !== null)
        .map(key => {
        const value = params[key];        
        if (Array.isArray(value)) {
            return value.filter(v => v !== undefined && v !== null).map(v => {
                return `${encodeURIComponent(key)}=${encodeURIComponent(v)}`
            }).join('&');
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        })
        .join('&');
    return queryString ? `?${queryString}` : '';
}